import { useMemo } from 'react';
import { Query } from '../../../../stores/searchQuery';
import { getMakeModelHitCount } from '../api';
import { useHitCounts } from './useHitCounts';

export const useMakeHitCount = (query: Query) => {
  const queryMemo = useMemo(() => ({ ...query, ms: undefined }), [query]);
  return useHitCounts(getMakeModelHitCount, queryMemo, 'MAKE');
};
